<div role="main">
  <app-header></app-header>

  <div class="col-md-6 offset-md-1 mb-5 d-flex align-items-center">
    <span class="text-white-ref ref">Reference ID</span>
    <span class="ref-id-no ms-2">{{ service.referenceFileDetails.referenceId }}</span>
  </div>
  <div class="text-white-lite" style="text-align: center;">
    <h1 style="font-size: 1.5rem;">
      <span> Thank you!</span>
    </h1>
    <i class="fa-solid fa-check"></i>
  </div>
  <div class="text-white-lite pad solid mb-4 reference-container">
    <div >
      <label class="text-white-ulte offset-md-2">Reference ID:</label>
      <span class="text-white-sub"> {{ service.referenceFileDetails.referenceId }}</span>
    </div>
    <div >
      <label class="text-white-ulte offset-md-2">Date Submitted:</label>
      <span class="text-white-sub"> {{ date | date }}</span>
    </div>
    <div >
      <label class="text-white-ulte offset-md-2">Number of Files Submitted:</label>
      <span class="text-white-sub"> {{ service.referenceFileDetails.files.length }}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-md-10 offset-md-1 text-white-sub mb-4">
      You will receive a Confirmation Email once all the files are successfully transferred. If you need to upload additional files, please go back to the FileCapture home page and use the
      Reference ID found in the request letter.
    </div>
  </div>

  <div class="offset-md-1 confirmationfooter">
    <button type="button" class="btn-enter" id="dashboardButton" ngbTooltip="Return to main page to enter a new reference ID." (click)="exit()">Enter New Reference ID</button> 
  </div>
  <!-- Footer -->
  <app-footer></app-footer>
</div>
